export default __webpack_public_path__ + "static/media/tablet-resizer-23.aef8b85c.svg";